import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import WasteTippingService from '../../services/WasteTippingService';
import DtnPhotoModal from '../Jobs/dtn/paritals/DtnPhotoModal';

class WasteTippingReceipts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            receipts: this.normalizeReceipts(props.receipts || []),
            uploading: false,
            dtnImageModalOpen: false,
            dtnImageModalIndex: 0,
        };

        this.service = new WasteTippingService();
    }

    normalizeReceipts = (receipts) => {
        return receipts.map((r) => ({
            id: r.id,
            name: r.name || (r.url ? r.url.split('/').pop() : ''),
            url: r.url,
            rotation: r.rotation || 0,
        }));
    };

    handleDrop = async (acceptedFiles) => {
        if (!acceptedFiles.length) return;

        this.setState({ uploading: true });

        try {
            const { data } = await this.service.uploadReceipts(this.props.wasteId, acceptedFiles);

            if (Array.isArray(data)) {
                this.setState((prev) => ({
                    receipts: [
                        ...prev.receipts,
                        ...data.map((r) => ({
                            id: r.id,
                            name: r.name,
                            url: r.url,
                            rotation: r.rotation || 0,
                        })),
                    ],
                }));
            } else {
                console.warn('Unexpected response:', data);
                alert('Upload failed');
            }
        } catch (err) {
            console.error('Upload failed', err);
            alert('Upload failed');
        } finally {
            this.setState({ uploading: false });
        }
    };

    deleteReceipt = async (id) => {
        if (!window.confirm('Delete this receipt?')) return;

        try {
            await this.service.deleteReceipt(this.props.wasteId, id);

            this.setState((prev) => ({
                receipts: prev.receipts.filter((r) => r.id !== id),
            }));
        } catch (err) {
            console.error(err);
            alert('Could not delete receipt');
        }
    };

    render() {
        const { receipts, uploading } = this.state;
        const { reviewed } = this.props;

        return (
            <section className="mt-4">
                <h6 className="cw-bg-grey text-white py-2 pl-2">Photos of Tipping Receipts</h6>

                <div className="row">
                    {receipts.map((r, index) =>
                        r.url ? (
                            <div key={r.id} className="col-md-3 mb-3 position-relative">
                                <img
                                    src={r.url}
                                    className="img-fluid"
                                    alt="Receipt"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        this.setState({
                                            dtnImageModalOpen: true,
                                            dtnImageModalIndex: index,
                                        });
                                    }}
                                />

                                {!reviewed && (
                                    <div className="d-flex justify-content-between mt-1">
                                        <button
                                            className="btn btn-sm btn-danger"
                                            onClick={() => this.deleteReceipt(r.id)}
                                        >
                                            <i className="fas fa-times" /> Delete
                                        </button>
                                    </div>
                                )}
                            </div>
                        ) : null
                    )}
                </div>

                {!reviewed && (
                    <Dropzone onDrop={this.handleDrop} maxSize={55000000}>
                        {({ getRootProps, getInputProps, isDragActive }) => (
                            <div
                                {...getRootProps()}
                                className={`jobs-dropzone d-flex flex-column align-items-center justify-content-center mt-3 ${
                                    isDragActive ? 'active' : ''
                                }`}
                            >
                                <input {...getInputProps()} />

                                {uploading ? (
                                    <p className="text-muted py-4 mb-0">Uploading receipts…</p>
                                ) : (
                                    <>
                                        <i className="fas fa-cloud-upload-alt fa-2x mb-2" />
                                        <p className="mb-0 text-muted">Drag & drop receipts here or click to upload</p>
                                    </>
                                )}
                            </div>
                        )}
                    </Dropzone>
                )}

                {this.state.dtnImageModalOpen && (
                    <DtnPhotoModal
                        media={receipts}
                        onClose={() => {
                            this.setState({
                                dtnImageModalOpen: false,
                            });
                        }}
                        index={this.state.dtnImageModalIndex}
                        title="Tipping Receipts"
                    />
                )}
            </section>
        );
    }
}

export default WasteTippingReceipts;
